module.exports = __webpack_public_path__ + "assets/img/Logo.6c161229.svg";